import { effectiveBisectDisableWsConnectGenGuards } from '../calls/callLifecycleDebug';

/**
 * Pure guard logic (for tests and documentation). Production uses
 * {@link shouldAbortWsConnect}, which passes {@link effectiveBisectDisableWsConnectGenGuards}.
 */
export function computeShouldAbortWsConnect(
  isActive: boolean,
  myGeneration: number,
  currentGeneration: number,
  bisectDisableGenerationGuards: boolean,
): boolean {
  if (!isActive) {
    return true;
  }
  if (bisectDisableGenerationGuards) {
    return false;
  }
  return myGeneration !== currentGeneration;
}

/**
 * Guards for async WebSocket connect: effect teardown or a superseding connect attempt
 * must not leave a zombie socket after await (e.g. ws-ticket fetch on web).
 */
export function shouldAbortWsConnect(
  isActive: boolean,
  myGeneration: number,
  currentGeneration: number,
): boolean {
  return computeShouldAbortWsConnect(
    isActive,
    myGeneration,
    currentGeneration,
    effectiveBisectDisableWsConnectGenGuards(),
  );
}
